import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { FormControl } from '@angular/forms';
@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class CheckboxComponent {
  @ViewChild('checkbox') checkbox: ElementRef | undefined;
  @Input() label: string = '';
  @Input() isForDisplay: boolean = false;
  @Input() checked: boolean = false;
  @Input() checkboxValue!: number;
  @Input() hasCheckboxOtherOption: boolean = false;
  @Input() addControl!: FormControl | any;
  @Output() checkboxClick: EventEmitter<any> = new EventEmitter();
  @Output() isCheckedChange = new EventEmitter<boolean>();

  handleCheckboxClick(event?: number): void {
    event ? this.checkboxClick.emit(event) :
      this.checkboxClick.emit(true);
  }
}
